export type CryptoData = {
  [key: string]: {
    minPriceIncrement: number;
    minSizeIncrement: number;
    minimumSize: number;
    maximumSize: number;
  };
};

const useCryptoMinMax = (): CryptoData => {
  const cryptoData: CryptoData = {
    Aave: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.0001,
      minimumSize: 0.03,
      maximumSize: 3000,
    },
    Algorand: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.0001,
      minimumSize: 25.0,
      maximumSize: 500000,
    },
    ApeCoin: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.01,
      minimumSize: 4.0,
      maximumSize: 10000,
    },
    Aptos: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.001,
      minimumSize: 0.5,
      maximumSize: 10000,
    },
    Arbitrum: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.0001,
      minimumSize: 8.0,
      maximumSize: 20000,
    },
    Arweave: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.001,
      minimumSize: 0.5,
      maximumSize: 4000,
    },
    Avalanche: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.0001,
      minimumSize: 0.1,
      maximumSize: 4000,
    },
    Balancer: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.0001,
      minimumSize: 1.5,
      maximumSize: 20000,
    },
    "Basic Attention": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.001,
      minimumSize: 0.001,
      maximumSize: 200000,
    },
    Bitcoin: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.0001,
      maximumSize: 50,
    },
    "Bitcoin Cash": {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.0001,
      minimumSize: 0.01,
      maximumSize: 300,
    },
    Blur: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.001,
      minimumSize: 20.0,
      maximumSize: 100000,
    },
    Cardano: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.0001,
      minimumSize: 10.0,
      maximumSize: 4000000,
    },
    Chainlink: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.0001,
      minimumSize: 0.2,
      maximumSize: 60000,
    },
    Compound: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.0001,
      minimumSize: 0.1,
      maximumSize: 6083,
    },
    Cosmos: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.0001,
      minimumSize: 0.5,
      maximumSize: 8500,
    },
    "Curve DAO": {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.001,
      minimumSize: 0.001,
      maximumSize: 200000,
    },
    Decentraland: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.01,
      minimumSize: 10.0,
      maximumSize: 50000,
    },
    Dogecoin: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.01,
      minimumSize: 30.0,
      maximumSize: 1000000,
    },
    EOS: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.0001,
      minimumSize: 5.0,
      maximumSize: 1000000,
    },
    Ethereum: {
      minPriceIncrement: 0.1,
      minSizeIncrement: 0.0001,
      minimumSize: 0.001,
      maximumSize: 1400,
    },
    "Ethereum Classic": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.0001,
      minimumSize: 0.1,
      maximumSize: 160000,
    },
    Filecoin: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.0001,
      minimumSize: 1.0,
      maximumSize: 30000,
    },
    Flow: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.0001,
      minimumSize: 5.0,
      maximumSize: 100000,
    },
    GALA: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.0001,
      minimumSize: 100.0,
      maximumSize: 1000000,
    },
    Hedera: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 4.0,
      maximumSize: 300000,
    },
    "Internet Computer": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.0001,
      minimumSize: 0.0001,
      maximumSize: 50000,
    },
    Immutable: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.01,
      minimumSize: 2.0,
      maximumSize: 20000,
    },
    Kusama: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.0001,
      minimumSize: 0.26,
      maximumSize: 1600,
    },
    Litecoin: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.0001,
      minimumSize: 0.1,
      maximumSize: 14000,
    },
    Maker: {
      minPriceIncrement: 0.1,
      minSizeIncrement: 0.000001,
      minimumSize: 0.0025,
      maximumSize: 40,
    },
    Moonbeam: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.0001,
      minimumSize: 25.0,
      maximumSize: 100000,
    },
    "NEAR Protocol": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.0001,
      minimumSize: 0.005,
      maximumSize: 35000,
    },
    Polkadot: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.01,
      minimumSize: 0.6,
      maximumSize: 100000,
    },
    Polygon: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.0001,
      minimumSize: 6.0,
      maximumSize: 4000000,
    },
    Quant: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.00001,
      minimumSize: 0.05,
      maximumSize: 200,
    },
    Solana: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.01,
      minimumSize: 0.02,
      maximumSize: 4000,
    },
    Stellar: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.0001,
      minimumSize: 100.0,
      maximumSize: 4000000,
    },
    Sui: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.0001,
      minimumSize: 3.0,
      maximumSize: 40000,
    },
    "Synthetix Network": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.001,
      minimumSize: 0.001,
      maximumSize: 20000,
    },
    Tezos: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.0001,
      minimumSize: 4.0,
      maximumSize: 80000,
    },
    "The Graph": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.0001,
      minimumSize: 0.1,
      maximumSize: 300000,
    },
    "The Sandbox": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.0001,
      minimumSize: 0.1,
      maximumSize: 50000,
    },
    TRON: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.0001,
      minimumSize: 33.0,
      maximumSize: 1600000,
    },
    Uniswap: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.0001,
      minimumSize: 0.5,
      maximumSize: 25000,
    },
    USDC: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.001,
      minimumSize: 5.0,
      maximumSize: 600000,
    },
    "XDC Network": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.0001,
      minimumSize: 0.1,
      maximumSize: 140000,
    },
    XRP: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.001,
      minimumSize: 5.0,
      maximumSize: 200000,
    },
    "Yearn Finance": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.000001,
      minimumSize: 0.000001,
      maximumSize: 11,
    },
    "1inch": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 11,
      maximumSize: 20700,
    },
    "Alchemy Pay": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 250,
      maximumSize: 315500,
    },
    Aevo: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 14.0,
      maximumSize: 10000,
    },
    "Akash Network": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1.2,
      maximumSize: 2200,
    },
    "Ankr Network": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 120,
      maximumSize: 220500,
    },
    API3: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 3.0,
      maximumSize: 2900,
    },
    Astar: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 70.0,
      maximumSize: 103900,
    },
    "Star Atlas": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1000,
      maximumSize: 2572700,
    },
    Audius: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 25.0,
      maximumSize: 51400,
    },
    "Axie Infinity": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.5,
      maximumSize: 1200,
    },
    Beam: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 280.0,
      maximumSize: 371600,
    },
    BarnBridge: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1.5,
      maximumSize: 3000,
    },
    Bonk: {
      minPriceIncrement: 0.00000001,
      minSizeIncrement: 0.1,
      minimumSize: 150000.0,
      maximumSize: 300030000,
    },
    Centrifuge: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 8.0,
      maximumSize: 14800,
    },
    Chiliz: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 50.0,
      maximumSize: 69900,
    },
    dYdX: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 5.0,
      maximumSize: 4600,
    },
    MultiversX: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.00001,
      minimumSize: 0.1,
      maximumSize: 300,
    },
    Ethena: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 15.0,
      maximumSize: 10200,
    },
    "Enjin Coin": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 15,
      maximumSize: 33600,
    },
    "Ethereum Name Service": {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.3,
      maximumSize: 400,
    },
    "Ether.fi": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00001,
      minimumSize: 0.8,
      maximumSize: 2100,
    },
    "Fetch.ai": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2.5,
      maximumSize: 4800,
    },
    Bonfida: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 14.0,
      maximumSize: 25200,
    },
    Flare: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.1,
      minimumSize: 150.0,
      maximumSize: 317100,
    },
    "Frax Share": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.5,
      maximumSize: 2100,
    },
    GMX: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.13,
      maximumSize: 200,
    },
    Gnosis: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.02,
      maximumSize: 29.54,
    },
    Hashflow: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 15.0,
      maximumSize: 31000,
    },
    Helium: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 0.65,
      maximumSize: 2500,
    },
    Injective: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.01,
      minimumSize: 0.15,
      maximumSize: 400,
    },
    JasmyCoin: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 130.0,
      maximumSize: 256600,
    },
    Jito: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 1.5,
      maximumSize: 2700,
    },
    Jupiter: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.0001,
      minimumSize: 5.0,
      maximumSize: 8800,
    },
    Kava: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 7.0,
      maximumSize: 14100,
    },
    "Lido DAO": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1.5,
      maximumSize: 4500,
    },
    LimeWire: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.001,
      minimumSize: 25.0,
      maximumSize: 22300,
    },
    Livepeer: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.3,
      maximumSize: 400,
    },
    "Mina Protocol": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 4,
      maximumSize: 11600,
    },
    Enzyme: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.3,
      maximumSize: 400,
    },
    Moonriver: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.5,
      maximumSize: 600,
    },
    Maple: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.001,
      minimumSize: 0.24,
      maximumSize: 600,
    },
    Nosana: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00001,
      minimumSize: 2.5,
      maximumSize: 2000,
    },
    "Ocean Protocol": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 6,
      maximumSize: 11200,
    },
    "OMG Network": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 7,
      maximumSize: 22800,
    },
    Ondo: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.001,
      minimumSize: 3.5,
      maximumSize: 7100,
    },
    Optimism: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 1.5,
      maximumSize: 4000,
    },
    Orca: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2.5,
      maximumSize: 4000,
    },
    Pepe: {
      minPriceIncrement: 0.00000001,
      minSizeIncrement: 0.1,
      minimumSize: 350000.0,
      maximumSize: 685401000,
    },
    "Perpetual Protocol": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 4,
      maximumSize: 8400,
    },
    "Pyth Network": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 9,
      maximumSize: 21200,
    },
    RARI: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.00000001,
      minimumSize: 1.8,
      maximumSize: 3600,
    },
    Raydium: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2.5,
      maximumSize: 5400,
    },
    Ren: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 90.0,
      maximumSize: 125300,
    },
    Render: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.01,
      minimumSize: 0.01,
      maximumSize: 900,
    },
    "Rocket Pool": {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.15,
      maximumSize: 400,
    },
    THORChain: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1.0,
      maximumSize: 1600,
    },
    Siacoin: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 650.0,
      maximumSize: 1524600,
    },
    Sei: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 7.0,
      maximumSize: 19200,
    },
    "Shiba Inu": {
      minPriceIncrement: 0.00000001,
      minSizeIncrement: 0.00001,
      minimumSize: 200000,
      maximumSize: 389408100,
    },
    Starknet: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.01,
      minimumSize: 10.0,
      maximumSize: 7700,
    },
    Stacks: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2.0,
      maximumSize: 4400,
    },
    SuperVerse: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 5.0,
      maximumSize: 9300,
    },
    Sushi: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 4.0,
      maximumSize: 8400,
    },
    Celestia: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 0.8,
      maximumSize: 1000,
    },
    Tensor: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 13.0,
      maximumSize: 7600,
    },
    TrueFi: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 25.0,
      maximumSize: 49300,
    },
    Wormhole: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 14.0,
      maximumSize: 16100,
    },
    Waves: {
      minPriceIncrement: 0.0,
      minSizeIncrement: 0.0,
      minimumSize: 0.0,
      maximumSize: 7000,
    },
    Wen: {
      minPriceIncrement: 0.00000001,
      minSizeIncrement: 1.0,
      minimumSize: 25000.0,
      maximumSize: 49043600,
    },
    dogwifhat: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.0001,
      minimumSize: 1.5,
      maximumSize: 3000,
    },
    "Zeus Network": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 11,
      maximumSize: 20400,
    },
    "0x Protocol": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 15,
      maximumSize: 18800,
    },
    BitTorrent: {
      minPriceIncrement: 0.00000001,
      minSizeIncrement: 0.00001,
      minimumSize: 5000000.0,
      maximumSize: 6371861858,
    },
    Civic: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 24.0,
      maximumSize: 30506,
    },
    Clearpool: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 33.0,
      maximumSize: 40917,
    },
    Cloud: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 12.0,
      maximumSize: 13499,
    },
    "Drift Protocol": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 7.5,
      maximumSize: 9275,
    },
    "Echelon Prime": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00001,
      minimumSize: 0.5,
      maximumSize: 574,
    },
    Eigenlayer: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00001,
      minimumSize: 1.0,
      maximumSize: 1718,
    },
    "Energy Web": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2,
      maximumSize: 4464,
    },
    EURC: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.01,
      minimumSize: 0.01,
      maximumSize: 5000,
    },
    Euler: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1.0,
      maximumSize: 1689,
    },
    FLOKI: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 1.0,
      minimumSize: 40000.0,
      maximumSize: 41390728,
    },
    GMT: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 20.0,
      maximumSize: 41322,
    },
    Hivemapper: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 50.0,
      maximumSize: 91258,
    },
    ICON: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 20.0,
      maximumSize: 39968,
    },
    Kamino: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 65.0,
      maximumSize: 61478,
    },
    Layer3: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 70.0,
      maximumSize: 92593,
    },
    Loopring: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.1,
      minimumSize: 20.0,
      maximumSize: 46773,
    },
    "Merit Circle": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2,
      maximumSize: 3650,
    },
    "Mog Coin": {
      minPriceIncrement: 0.000000001,
      minSizeIncrement: 0.00001,
      minimumSize: 3500000,
      maximumSize: 2847380410,
    },
    Parcl: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 20.0,
      maximumSize: 24143,
    },
    Pendle: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00001,
      minimumSize: 1.2,
      maximumSize: 1462,
    },
    "POL (ex-MATIC)": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 6,
      maximumSize: 142857,
    },
    Popcat: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 3.5,
      maximumSize: 4505,
    },
    Saga: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00001,
      minimumSize: 2.0,
      maximumSize: 2304,
    },
    Secret: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 13.0,
      maximumSize: 28233,
    },
    Sky: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 80.0,
      maximumSize: 90794,
    },
    "Stargate Finance": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 8,
      maximumSize: 18362,
    },
    "Step Finance": {
      minPriceIncrement: 0.00000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 80,
      maximumSize: 123153,
    },
    Storj: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 7.0,
      maximumSize: 14096,
    },
    Synapse: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 7.0,
      maximumSize: 12438,
    },
    "Threshold Network": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 180,
      maximumSize: 223314,
    },
    Turbo: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 750.0,
      maximumSize: 1088613,
    },
    ZetaChain: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.00001,
      minimumSize: 5.0,
      maximumSize: 9391,
    },
    Zeta: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 130.0,
      maximumSize: 97493,
    },
    ZKsync: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 35.0,
      maximumSize: 43365,
    },
    Bittensor: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 0.008,
      maximumSize: 10,
    },
    Arkham: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 3.0,
      maximumSize: 4065,
    },
    Mantle: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 6.0,
      maximumSize: 5000,
    },
    Toncoin: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.0001,
      minimumSize: 1.0,
      maximumSize: 1000,
    },
    Syrup: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 25.0,
      maximumSize: 25000,
    },
    Kaspa: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.0001,
      minimumSize: 30.0,
      maximumSize: 25000,
    },
    "Render (SOL)": {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.0001,
      minimumSize: 1.0,
      maximumSize: 1000,
    },
    Arcblock: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 10.0,
      maximumSize: 19160.0,
    },
    Acala: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 69.0,
      maximumSize: 621900.0,
    },
    Fusionist: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 4.0,
      maximumSize: 31180.0,
    },
    "Act I The AI Prophecy": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 20.0,
      maximumSize: 329240.0,
    },
    "Across Protocol": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 52.0,
      maximumSize: 89130.0,
    },
    AdEx: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 31.0,
      maximumSize: 173560.0,
    },
    Aergo: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 54.0,
      maximumSize: 142050.0,
    },
    "Aerodrome Finance": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 5.0,
      maximumSize: 32490.0,
    },
    "Adventure Gold": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 10.0,
      maximumSize: 21400.0,
    },
    "AIOZ Network": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 22.0,
      maximumSize: 44230.0,
    },
    "aixbt by Virtuals": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 21.0,
      maximumSize: 89560.0,
    },
    "My Neighbor Alice": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 19.0,
      maximumSize: 41820.0,
    },
    Stella: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 339.0,
      maximumSize: 674770.0,
    },
    AltLayer: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 51.0,
      maximumSize: 618820.0,
    },
    Amp: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1942.0,
      maximumSize: 4148240.0,
    },
    Animecoin: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 77.0,
      maximumSize: 723250.0,
    },
    ARK: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 13.0,
      maximumSize: 46100.0,
    },
    ARPA: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 361.0,
      maximumSize: 774800.0,
    },
    Automata: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 68.0,
      maximumSize: 382460.0,
    },
    Aethir: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 96.0,
      maximumSize: 351380.0,
    },
    Bounce: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.39,
      maximumSize: 1640.0,
    },
    "AVA (Travala)": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 14.0,
      maximumSize: 32170.0,
    },
    Axelar: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 22.0,
      maximumSize: 53580.0,
    },
    Babylon: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 99.0,
      maximumSize: 264230.0,
    },
    "Banana Gun": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.16,
      maximumSize: 750.0,
    },
    "Band Protocol": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 12.0,
      maximumSize: 26180.0,
    },
    "Bella Protocol": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 30.0,
      maximumSize: 59840.0,
    },
    Biconomy: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 23.0,
      maximumSize: 163510.0,
    },
    "Big Time": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 46.0,
      maximumSize: 281010.0,
    },
    "Bio Protocol": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 10.0,
      maximumSize: 250000.0,
    },
    Blast: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 767.0,
      maximumSize: 6097570.0,
    },
    Bluzelle: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 211.0,
      maximumSize: 457180.0,
    },
    BNB: {
      minPriceIncrement: 0.01,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.02,
      maximumSize: 30.0,
    },
    "Bancor Network": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 12.0,
      maximumSize: 26540.0,
    },
    "BOOK OF MEME": {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1050.0,
      maximumSize: 9107470.0,
    },
    Brett: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 171.0,
      maximumSize: 316060.0,
    },
    Coin98: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 40.0,
      maximumSize: 329020.0,
    },
    PancakeSwap: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 3.0,
      maximumSize: 7360.0,
    },
    Catizen: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 18.0,
      maximumSize: 169920.0,
    },
    Celo: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 24.0,
      maximumSize: 51460.0,
    },
    "Celer Network": {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 690.0,
      maximumSize: 2061010.0,
    },
    "Cetus Protocol": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 19.0,
      maximumSize: 123160.0,
    },
    Conflux: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 40.0,
      maximumSize: 220950.0,
    },
    "Just a chill guy": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 34.0,
      maximumSize: 246960.0,
    },
    Chromia: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 92.0,
      maximumSize: 201130.0,
    },
    "Nervos Network": {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1964.0,
      maximumSize: 3894090.0,
    },
    "Clover Finance": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 104.0,
      maximumSize: 659000.0,
    },
    Core: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 6.0,
      maximumSize: 25000.0,
    },
    Contentos: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 772.0,
      maximumSize: 5423000.0,
    },
    COTI: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 142.0,
      maximumSize: 282860.0,
    },
    "CoW Protocol": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 11.0,
      maximumSize: 44530.0,
    },
    Cronos: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 79.0,
      maximumSize: 158900.0,
    },
    "Casper Network": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 429.0,
      maximumSize: 1335710.0,
    },
    Creditcoin: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 6.0,
      maximumSize: 28000.0,
    },
    Shentu: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 9.0,
      maximumSize: 53220.0,
    },
    Cartesi: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 42.0,
      maximumSize: 264790.0,
    },
    "Convex Finance": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2.0,
      maximumSize: 6150.0,
    },
    CYBER: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 69.0,
      maximumSize: 13640.0,
    },
    "Dar Open Network": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 107.0,
      maximumSize: 486230.0,
    },
    Streamr: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 571.0,
      maximumSize: 1285350.0,
    },
    deBridge: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 204.0,
      maximumSize: 1209680.0,
    },
    Decred: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.48,
      maximumSize: 1190.0,
    },
    DeepBook: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 58.0,
      maximumSize: 112870.0,
    },
    Degen: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1959.0,
      maximumSize: 3753760.0,
    },
    Dent: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 5431.0,
      maximumSize: 23677980.0,
    },
    DigiByte: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 581.0,
      maximumSize: 1855980.0,
    },
    DIA: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 19.0,
      maximumSize: 40830.0,
    },
    district0x: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 163.0,
      maximumSize: 609760.0,
    },
    DODO: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 44.0,
      maximumSize: 404210.0,
    },
    Dogs: {
      minPriceIncrement: 0.00000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 12489.0,
      maximumSize: 113464450.0,
    },
    DUSK: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 33.0,
      maximumSize: 246760.0,
    },
    Dymension: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 5.0,
      maximumSize: 58740.0,
    },
    "Open Campus": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 13.0,
      maximumSize: 126160.0,
    },
    Elixir: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 13.0,
      maximumSize: 162820.0,
    },
    "Epic Chain": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 5.0,
      maximumSize: 14020.0,
    },
    EURØP: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 5.0,
      maximumSize: 100000.0,
    },
    SynFutures: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 173.0,
      maximumSize: 1526100.0,
    },
    Stafi: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 15.0,
      maximumSize: 110460.0,
    },
    Flux: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 11.0,
      maximumSize: 74260.0,
    },
    Four: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 4.0,
      maximumSize: 6000.0,
    },
    "Ampleforth Governance": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2.0,
      maximumSize: 7290.0,
    },
    Fuel: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 173.0,
      maximumSize: 1800000.0,
    },
    Gravity: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 237.0,
      maximumSize: 1330970.0,
    },
    Gas: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2.0,
      maximumSize: 5750.0,
    },
    Aavegotchi: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 20.0,
      maximumSize: 42270.0,
    },
    Gigachad: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 136.0,
      maximumSize: 750000.0,
    },
    Golem: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 19.0,
      maximumSize: 72820.0,
    },
    "Gains Network": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 4.0,
      maximumSize: 15000.0,
    },
    "Goatseus Maximus": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 13.0,
      maximumSize: 135630.0,
    },
    Grass: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 3.0,
      maximumSize: 9260.0,
    },
    Heima: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 9.0,
      maximumSize: 54830.0,
    },
    "Hifi Finance": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 13.0,
      maximumSize: 196060.0,
    },
    Highstreet: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 5.0,
      maximumSize: 31150.0,
    },
    "Hamster Kombat": {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2517.0,
      maximumSize: 8370540.0,
    },
    "Hooked Protocol": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 16.0,
      maximumSize: 147790.0,
    },
    Holo: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 8165.0,
      maximumSize: 17117430.0,
    },
    Hyperliquid: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.27,
      maximumSize: 510.0,
    },
    "SPACE ID": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 17.0,
      maximumSize: 96900.0,
    },
    IDEX: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 121.0,
      maximumSize: 722200.0,
    },
    Illuvium: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.15,
      maximumSize: 1320.0,
    },
    "io.net": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2.0,
      maximumSize: 20380.0,
    },
    IOST: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 993.0,
      maximumSize: 4961960.0,
    },
    IOTA: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 43.0,
      maximumSize: 87370.0,
    },
    IoTeX: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 313.0,
      maximumSize: 760270.0,
    },
    Story: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 7.0,
      maximumSize: 4030.0,
    },
    IQ: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 931.0,
      maximumSize: 4435250.0,
    },
    JUST: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 209.0,
      maximumSize: 520840.0,
    },
    Kaia: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 30.0,
      maximumSize: 161240.0,
    },
    KAITO: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 4.0,
      maximumSize: 8580.0,
    },
    Kadena: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 19.0,
      maximumSize: 36390.0,
    },
    KernelDAO: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 4.0,
      maximumSize: 114950.0,
    },
    Komodo: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 83.0,
      maximumSize: 140320.0,
    },
    "Kyber Network Crystal": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 22.0,
      maximumSize: 54630.0,
    },
    "Lista DAO": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 15.0,
      maximumSize: 80350.0,
    },
    Liquity: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 4.0,
      maximumSize: 22980.0,
    },
    Lisk: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 18.0,
      maximumSize: 38820.0,
    },
    "LTO Network": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 230.0,
      maximumSize: 508480.0,
    },
    Lumia: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 7.0,
      maximumSize: 59250.0,
    },
    LUKSO: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 406.0,
      maximumSize: 17260.0,
    },
    Treasure: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 15.0,
      maximumSize: 129430.0,
    },
    "Manta Network": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 8.0,
      maximumSize: 65510.0,
    },
    "Mask Network": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 3.0,
      maximumSize: 8340.0,
    },
    "Maverick Protocol": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 33.0,
      maximumSize: 310820.0,
    },
    "Heroes of Mavia": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 49.0,
      maximumSize: 106310.0,
    },
    Mobox: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 32.0,
      maximumSize: 322720.0,
    },
    "Measurable Data": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 486.0,
      maximumSize: 641580.0,
    },
    "Magic Eden": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 6.0,
      maximumSize: 21700.0,
    },
    Memecoin: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 628.0,
      maximumSize: 9025280.0,
    },
    "Merlin Chain": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 58.0,
      maximumSize: 150000.0,
    },
    Metis: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.15,
      maximumSize: 970.0,
    },
    "cat in a dogs world": {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1058.0,
      maximumSize: 5248430.0,
    },
    michi: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 87.0,
      maximumSize: 426380.0,
    },
    "Moca Network": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 22.0,
      maximumSize: 216920.0,
    },
    "Moo Deng": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 38.0,
      maximumSize: 82420.0,
    },
    Morpho: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 3.0,
      maximumSize: 12830.0,
    },
    Movement: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 10.0,
      maximumSize: 121760.0,
    },
    "Metal DAO": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 7.0,
      maximumSize: 23520.0,
    },
    Nano: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 8.0,
      maximumSize: 18510.0,
    },
    Neiro: {
      minPriceIncrement: 0.00000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 15110.0,
      maximumSize: 36845990.0,
    },
    NEO: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.45,
      maximumSize: 2860.0,
    },
    NFPrompt: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 26.0,
      maximumSize: 234310.0,
    },
    Nillion: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 9.0,
      maximumSize: 39770.0,
    },
    NKN: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 287.0,
      maximumSize: 569260.0,
    },
    Numeraire: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.93,
      maximumSize: 2020.0,
    },
    Notcoin: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 3522.0,
      maximumSize: 7587260.0,
    },
    "Non-Playable Coin": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 237.0,
      maximumSize: 1207730.0,
    },
    "Origin Token": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 138.0,
      maximumSize: 291830.0,
    },
    MANTRA: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 29.0,
      maximumSize: 54250.0,
    },
    "Omni Network": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.71,
      maximumSize: 7540.0,
    },
    Harmony: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 670.0,
      maximumSize: 1399260.0,
    },
    "Ontology Gas": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 23.0,
      maximumSize: 95910.0,
    },
    Ontology: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 58.0,
      maximumSize: 129990.0,
    },
    ORDI: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.25,
      maximumSize: 1990.0,
    },
    Osmosis: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 14.0,
      maximumSize: 79920.0,
    },
    "Orchid Protocol": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 127.0,
      maximumSize: 306250.0,
    },
    "Particle Network": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 35.0,
      maximumSize: 74630.0,
    },
    peaq: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 13.0,
      maximumSize: 156830.0,
    },
    "Pudgy Penguins": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 515.0,
      maximumSize: 1661870.0,
    },
    ConstitutionDAO: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 145.0,
      maximumSize: 839400.0,
    },
    PHALA: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 51.0,
      maximumSize: 122450.0,
    },
    Phoenix: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 5.0,
      maximumSize: 31930.0,
    },
    Pixels: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 38.0,
      maximumSize: 380620.0,
    },
    Plume: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 69.0,
      maximumSize: 123460.0,
    },
    "Peanut the Squirrel": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 21.0,
      maximumSize: 64800.0,
    },
    Polkastarter: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 38.0,
      maximumSize: 79960.0,
    },
    Polymesh: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 24.0,
      maximumSize: 121860.0,
    },
    Marlin: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 349.0,
      maximumSize: 1799000.0,
    },
    PONKE: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 19.0,
      maximumSize: 125110.0,
    },
    Portal: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 183.0,
      maximumSize: 348520.0,
    },
    Powerledger: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 28.0,
      maximumSize: 105640.0,
    },
    Prom: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2.0,
      maximumSize: 3120.0,
    },
    Wayfinder: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 35.0,
      maximumSize: 91860.0,
    },
    Puffer: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 43.0,
      maximumSize: 91750.0,
    },
    "Pundi X": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 15.0,
      maximumSize: 52070.0,
    },
    "Vulcan Forged": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 3.0,
      maximumSize: 16080.0,
    },
    QuarkChain: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1074.0,
      maximumSize: 2457010.0,
    },
    Qtum: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 4.0,
      maximumSize: 8480.0,
    },
    Radworks: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 6.0,
      maximumSize: 24790.0,
    },
    SuperRare: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 56.0,
      maximumSize: 306000.0,
    },
    "Radiant Capital": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 111.0,
      maximumSize: 707220.0,
    },
    RedStone: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 9.0,
      maximumSize: 46880.0,
    },
    Request: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 60.0,
      maximumSize: 122250.0,
    },
    Renzo: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 177.0,
      maximumSize: 1511640.0,
    },
    "iExec RLC": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 8.0,
      maximumSize: 16280.0,
    },
    Ronin: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 6.0,
      maximumSize: 28250.0,
    },
    Oasis: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 77.0,
      maximumSize: 582300.0,
    },
    "Reserve Rights": {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 960.0,
      maximumSize: 2332090.0,
    },
    Ravencoin: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 380.0,
      maximumSize: 1538620.0,
    },
    Sonic: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 22.0,
      maximumSize: 42830.0,
    },
    Safe: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 7.0,
      maximumSize: 31050.0,
    },
    Scroll: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 7.0,
      maximumSize: 61030.0,
    },
    SafePal: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 11.0,
      maximumSize: 34970.0,
    },
    SKALE: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 134.0,
      maximumSize: 797030.0,
    },
    "Self Chain": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 21.0,
      maximumSize: 89450.0,
    },
    "Smooth Love Potion": {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1568.0,
      maximumSize: 11718750.0,
    },
    SPX6900: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 9.0,
      maximumSize: 16540.0,
    },
    "SSV Network": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.3,
      maximumSize: 1890.0,
    },
    Stratis: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 114.0,
      maximumSize: 373230.0,
    },
    Sweat: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1081.0,
      maximumSize: 4859090.0,
    },
    Swell: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 200.0,
      maximumSize: 1909130.0,
    },
    Solar: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 43.0,
      maximumSize: 97410.0,
    },
    "TARS AI": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 80.0,
      maximumSize: 143130.0,
    },
    Taiko: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 5.0,
      maximumSize: 27590.0,
    },
    Thena: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 6.0,
      maximumSize: 67600.0,
    },
    "Theta Network": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 4.0,
      maximumSize: 21030.0,
    },
    "Alien Worlds": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 467.0,
      maximumSize: 3570580.0,
    },
    TokenFi: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 133.0,
      maximumSize: 952390.0,
    },
    OriginTrail: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 20.0,
      maximumSize: 41660.0,
    },
    "Tellor Tributes": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.18,
      maximumSize: 410.0,
    },
    "Official Trump": {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.74,
      maximumSize: 1510.0,
    },
    "Trust Wallet": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 6.0,
      maximumSize: 21590.0,
    },
    UMA: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 6.0,
      maximumSize: 15360.0,
    },
    xMoney: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 266.0,
      maximumSize: 604360.0,
    },
    UXLINK: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 6.0,
      maximumSize: 50000.0,
    },
    Vana: {
      minPriceIncrement: 0.001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2.0,
      maximumSize: 2730.0,
    },
    "Vanar Chain": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 57.0,
      maximumSize: 489240.0,
    },
    Velo: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 263.0,
      maximumSize: 1307760.0,
    },
    VeChain: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 138.0,
      maximumSize: 697030.0,
    },
    Viction: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 18.0,
      maximumSize: 85280.0,
    },
    "Virtuals Protocol": {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 3.0,
      maximumSize: 8200.0,
    },
    Verasity: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1725.0,
      maximumSize: 12000000.0,
    },
    VeThor: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 3666.0,
      maximumSize: 7861640.0,
    },
    Walrus: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 14.0,
      maximumSize: 34170.0,
    },
    WAX: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 341.0,
      maximumSize: 799580.0,
    },
    "WalletConnect Token": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 14.0,
      maximumSize: 28810.0,
    },
    WINkLink: {
      minPriceIncrement: 0.00000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 62620.0,
      maximumSize: 331858410.0,
    },
    Worldcoin: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 8.0,
      maximumSize: 14710.0,
    },
    WOO: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 31.0,
      maximumSize: 225330.0,
    },
    Xai: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 27.0,
      maximumSize: 239810.0,
    },
    Verge: {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 1442.0,
      maximumSize: 2508790.0,
    },
    "XYO Network": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 329.0,
      maximumSize: 1522380.0,
    },
    "Yield Guild Games": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 13.0,
      maximumSize: 90200.0,
    },
    Horizen: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 0.87,
      maximumSize: 2000.0,
    },
    Zilliqa: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 312.0,
      maximumSize: 1495520.0,
    },
    Zircuit: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 95.0,
      maximumSize: 472740.0,
    },
    LayerZero: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00000001,
      minimumSize: 2.0,
      maximumSize: 7430.0,
    },
    Initia: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 23.0,
      maximumSize: 23810.0,
    },
    Sophon: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00000001,
      minimumSize: 87.0,
      maximumSize: 339060.0,
    },
    Gitcoin: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 10.0,
      maximumSize: 98386.0,
    },
    Fartcoin: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 8.0,
      maximumSize: 20000.0,
    },
    MyShell: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00000001,
      minimumSize: 12.0,
      maximumSize: 100000.0,
    },
    Vaulta: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.0001,
      minimumSize: 9.0,
      maximumSize: 30000.0,
    },
    Xion: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 2.0,
      maximumSize: 11078.0,
    },
    "Space and Time": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.0001,
      minimumSize: 44.0,
      maximumSize: 141703.0,
    },
    "Haedal Protocol": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00001,
      minimumSize: 69.0,
      maximumSize: 87566.0,
    },
    HOME: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.0001,
      minimumSize: 156.0,
      maximumSize: 257268.0,
    },
    Spark: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.0001,
      minimumSize: 77.0,
      maximumSize: 134012.0,
    },
    "Newton Protocol": {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 17.0,
      maximumSize: 36536.0,
    },
    Sign: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.0001,
      minimumSize: 10.0,
      maximumSize: 168805.0,
    },
    "Impossible Cloud Network Token": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.00001,
      minimumSize: 345.0,
      maximumSize: 33535.0,
    },
    DeLorean: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.001,
      minimumSize: 134.0,
      maximumSize: 2877698.0,
    },
    "Huma Finance": {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.0001,
      minimumSize: 140.0,
      maximumSize: 318167.0,
    },
    "Pump.fun": {
      minPriceIncrement: 0.0000001,
      minSizeIncrement: 0.001,
      minimumSize: 1739.0,
      maximumSize: 3194888.0,
    },
    Ika: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.0001,
      minimumSize: 233.0,
      maximumSize: 331236.0,
    },
    Treehouse: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 22.0,
      maximumSize: 31847.0,
    },
    SQD: {
      minPriceIncrement: 0.00001,
      minSizeIncrement: 0.00001,
      minimumSize: 35.0,
      maximumSize: 87642.0,
    },
    Towns: {
      minPriceIncrement: 0.000001,
      minSizeIncrement: 0.0001,
      minimumSize: 170.0,
      maximumSize: 395883.0,
    },
    Succinct: {
      minPriceIncrement: 0.0001,
      minSizeIncrement: 0.00001,
      minimumSize: 6.0,
      maximumSize: 8929.0,
    },
  };

  return cryptoData;
};

export default useCryptoMinMax;
